const videoSource22 = [
  {
    id: "video16",
    src: require("./4_1.mp4"),
  },
];

export default videoSource22;
